import * as React from 'react';
import styled from 'styled-components';

interface IAvatarProps {
    url: string;
    name: string;
    dimensionClasses?: string;
    size?: number;
}

// Styled components
const AvatarImage = styled.img<{ size?: number; className?: string }>`
  border-radius: 9999px;
  width: ${(props) => (props.size ? `${props.size}px` : '32px')};
  height: ${(props) => (props.size ? `${props.size}px` : '32px')};
`;

const AvatarInitials = styled.div<{ size?: number; className?: string }>`
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #C27CF9;
  width: ${(props) => (props.size ? `${props.size}px` : '32px')};
  height: ${(props) => (props.size ? `${props.size}px` : '32px')};
`;

const InitialsText = styled.span`
  font-size: 12px;
  color: white;
`;

const getInitials = (name: string) => {
    if (!name) return '';
    const nameParts = name.split(' ');
    return nameParts.length > 1
        ? `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase()
        : nameParts[0].slice(0, 2).toUpperCase();
};

const Avatar: React.FunctionComponent<IAvatarProps> = ({
    url,
    name,
    size,
    dimensionClasses = 'w-[32px] h-[32px]'
}) => {
    // Extract pixel size from dimensionClasses if provided
    const extractSize = () => {
        if (size) return size;

        const widthMatch = dimensionClasses.match(/w-\[(\d+)px\]/);
        if (widthMatch && widthMatch[1]) {
            return parseInt(widthMatch[1]);
        }
        return 32;
    };

    const avatarSize = extractSize();

    return url ? (
        <AvatarImage src={url} alt={name} size={avatarSize} />
    ) : (
        <AvatarInitials size={avatarSize}>
            <InitialsText>{getInitials(name)}</InitialsText>
        </AvatarInitials>
    );
};

export default Avatar;
